/** Centered card holder for the public auth screens. */
export default function AuthLayout({ children }) {
  return (
    <div style={{ minHeight: "100vh", padding: "48px 16px" }}>
      <div style={{ maxWidth: 420, margin: "0 auto" }}>{children}</div>
    </div>
  );
}
